// Stepper - visualisiert die 6 Schritte des Wizards.
// Node zeigt Icon-Nummer wenn future/active, Check wenn done. Konnektor
// zwischen zwei Nodes fuellt sich von links, sobald done.

import React from "react";
import { useLang } from "../i18n";

const STEP_ICONS = ["ic-step-space", "ic-step-landscape", "ic-step-package", "ic-step-artifacts", "ic-step-config", "ic-step-review"];

// skip: echte Schritt-Indizes, die im aktuellen Fluss nicht vorkommen (z. B. 1 ohne Werke).
// Die sichtbaren Schritte werden fortlaufend nummeriert, die Texte bleiben an ihrem echten Index.
export default function Stepper({ active, onJump, skip = [] }) {
  const { t } = useLang();
  const sichtbar = STEP_ICONS.map((icon, i) => ({ icon, i })).filter(({ i }) => !skip.includes(i));
  return (
    <div className="stepper">
      {sichtbar.map(({ icon, i }, pos) => {
        const done = i < active;
        const isActive = i === active;
        const clickable = typeof onJump === "function" && (done || isActive);
        return (
          <React.Fragment key={icon}>
            {pos > 0 && <div className={"step-connector" + (i <= active ? " filled" : "")} />}
            <div className={"step" + (isActive ? " is-active" : "")}>
              <div
                className={"step-node" + (done ? " done" : "") + (isActive ? " active" : "")}
                tabIndex={clickable ? 0 : -1}
                role={clickable ? "button" : undefined}
                aria-label={t("step" + i + ".l1")}
                onClick={clickable ? () => onJump(i) : undefined}
                onKeyDown={clickable ? event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); onJump(i); } } : undefined}
                style={clickable ? { cursor: "pointer" } : undefined}
              >
                <svg className="ic ic-20 icon-num"><use href={"#" + icon} /></svg>
                <svg className="ic ic-20 icon-check"><use href="#ic-check" /></svg>
              </div>
              <div className="step-txt">
                <div className="l1"><span className="no">{pos}</span>{t("step" + i + ".l1")}</div>
                <div className="l2">{t("step" + i + ".l2")}</div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}
